import { BACKEND_BASE_URL } from "./backendBaseUrl";
export const USER_BASE_URL = BACKEND_BASE_URL + "/user";

export const LOGIN = "/";
export const ALL_USERS = "/all";
export const ALL_USERS_BY_EMAILS = "/users_by_emails";
